import { arrow } from "@/designSystemIcons";
import { cn } from "@/lib/utils";
import { useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";

import Button from "../Button";
import { Variant } from "../Types";

export interface BaseDropdownOption {
  label: string;
  value: string;
}

interface BaseDropdownProps {
  label: string;
  children: React.ReactNode;
  open: boolean;
  variant?: Variant;
  setOpen: (open: boolean) => void;
}

const BaseDropdown = ({
  label,
  children,
  open,
  variant,
  setOpen,
}: BaseDropdownProps) => {
  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => setOpen(false));

  return (
    <div className="relative flex gap-x-1" ref={ref}>
      <Button
        variant={variant}
        label={label}
        onClick={() => setOpen(!open)}
        icon={
          <div className={cn("w-2 h-2", open && "rotate-180")}>{arrow}</div>
        }
      />
      {open && (
        <div className="absolute flex flex-col right-0 text-right top-full mt-1 rounded whitespace-nowrap max-h-96 overflow-y-auto overflow-x-hidden min-w-28 z-30 text-white bg-panel-background shadow-button">
          {children}
        </div>
      )}
    </div>
  );
};

export default BaseDropdown;
